import { useRef } from 'react';
import { BASE_PDF_STYLES } from '../../../../../utils/reportUtils';
import SuccessFormMessage from '../../../../components/messages/SuccessFormMessage';
import ReportButton from '../../../../components/report/ReportButton';
import ContractAttachmentsSummary from './ContractAttachmentsSummary';
import ContractSummary from './ContractSummary';
import GeneralInfoSummary from './GeneralInfoSummary';
import JobSummary from './JobSummary';
import { ContractDraftAttachment } from '../../../../Interfaces/Accounting/ACForms.interfaces';

type ContractSuccessMessageProps = {
  extraJobNumber?: string;
  attachments?: ContractDraftAttachment[];
};

const ContractSuccessMessage = ({
  extraJobNumber,
  attachments,
}: ContractSuccessMessageProps) => {
  const summaryRef = useRef<HTMLDivElement | null>(null);

  return (
    <div>
      <SuccessFormMessage
        message="The Contract has been uploaded for creation!"
        redirectUrl="/accounting-dashboard/new"
        redirectMessage="Click here to return to the forms list"
      />
      <div
        id="contract-success"
        className="w-fit mx-auto flex flex-column gap-3"
        ref={summaryRef}
      >
        <div className="text-30px font-bold mt-6 flex justify-content-between align-items-end">
          Contract Summary:
          <div className="text-23px cursor-pointer printHide h-fit">
            <ReportButton
              elementToPrintRef={summaryRef}
              fileName="Contract_Form"
              pdfStyles={BASE_PDF_STYLES}
              noButton={true}
              hideExcel={true}
              isPdfPortrait={true}
              widthElementID="contract-success"
              minWidth={800}
            />
          </div>
        </div>
        <ContractSummary />
        <JobSummary extraJobNumber={extraJobNumber} />
        <GeneralInfoSummary />
        <ContractAttachmentsSummary attachments={attachments} />
      </div>
    </div>
  );
};

export default ContractSuccessMessage;
